import Api from "../../axios";

export const postDeleteCompoffRequest = async (payload) => {
  return await Api.delete(`/delete_compoff?compoff_id=${payload.compoff_id}`);
};
